module.exports = __webpack_public_path__ + "img/slick-slider-nav-prev.2bec838b.svg";